/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Skeleton, { SkeletonTheme as ST } from 'react-loading-skeleton';

export default props => <Skeleton {...props} />;
export const SkeletonTheme = props => <ST {...props} />;
